import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { Event } from '../interfaces/event';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Tag } from '../interfaces/tag';
import { EventTypeEnum } from '../helpers/event-type.enum';
import { UserModel } from '../models/user.model';

@Injectable()
export class EventsService {
  private url: string;

  constructor(private http: HttpClient) {
    this.url = `${environment.EVENTS_API_URL}`;
  }

  getEvents(query: any): Observable<Event[]> {
    const queryParams = new HttpParams().set('filter', JSON.stringify(query));
    return this.http.get<Event[]>(this.url, { params: queryParams });
  }

  getEventTypes(query): Observable<any[]> {
    const filter = query.length ? { 'tags.value': { $all: query } } : {};
    const queryParams = new HttpParams().set('filter', JSON.stringify(filter));
    return this.http.get<Event[]>(`${this.url}/eventTypes`, { params: queryParams });
  }

  getEventById(id: string): Observable<Event> {
    return this.http.get<Event>(`${this.url}/${id}`);
  }

  createEvent(event: Event): Observable<Event> {
    return this.http.post<Event>(this.url, event);
  }

  updateEvent(id: string, event: Event): Observable<Event> {
    return this.http.put<Event>(`${this.url}/${id}`, event);
  }

  deleteEvent(id: string): Observable<Event> {
    return this.http.delete<Event>(`${this.url}/${id}`);
  }

  findTags(): Observable<Tag[]> {
    return this.http.get<Tag[]>(`${this.url}/tags`);
  }

  getFetchUserEvent(user: UserModel, ip: string): Event {
    const tags: Tag[] = [
      {
        category: 'eventType',
        value: EventTypeEnum.USER_FETCHED
      },
      {
        category: 'userRole',
        value: user.getSalesChannel()
      },
      {
        category: 'userType',
        value: user.get('userType')
      },
      {
        category: 'username',
        value: user.get('username')
      },
      {
        category: 'userCreated',
        value: user.get('created')
      },
      {
        category: 'userIP',
        value: ip
      }
    ];

    return {
      value: 1,
      eventType: EventTypeEnum.USER_FETCHED,
      tags
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/events.service.ts